import { propOr } from 'ramda';
import { useBonusesStore } from '../../store';

const selectBsFundsBonuses = () => propOr({}, 'bsFundsBonuses');
const selectCrmFundsBonuses = () => propOr({}, 'crmFundsBonuses');

export const useFundsBonuses = () => {
  const bsFundsBonuses = useBonusesStore(selectBsFundsBonuses());
  const crmFundsBonuses = useBonusesStore(selectCrmFundsBonuses());
  const { data: bsBonusesData, ids: bsBonusesIds } = bsFundsBonuses;
  const { data: crmBonusesData, ids: crmBonusesIds } = crmFundsBonuses;
  const mergedBonusesData = {
    ...bsBonusesData,
    ...crmBonusesData
  };

  return [...bsBonusesIds, ...crmBonusesIds].map((id) => mergedBonusesData[id]);
};
